import { Component, inject, Injectable } from "@angular/core";
import { ERPEntityMappingService } from "./ERPEntityMapping.service";
import { UserLoginService } from "../login/userlogin.service";
import {
  ERPCompanyOnboardingRequestDTO,
  ERPUserDeleteRequestDTO,
  ERPUserMasterOnboardingRequestDTO,
} from "./ERPEntityMapping.interface";
import { Observable } from "rxjs";

export interface ERPEntityMappingCreateRequirement {
  masterType: string;
  masterId: number;
  affiliationType: string;
}

export interface ERPUserCredentialsCreateRequirement {
  softwareId: number;
  roleId: number;
  userName: string;
  userPassword: string;
}

@Injectable({
  providedIn: "root",
})
@Component({
  selector: "app-erp",
  templateUrl: "./erp.component.html",
  styleUrls: ["./erp.component.css"],
})
export class ERPComponent {
  private erpEntityMappingService = inject(ERPEntityMappingService);
  private User = inject(UserLoginService).User();

  companyOnboardingCreate(data: ERPCompanyOnboardingRequestDTO) {
    this.erpEntityMappingService.ERPCompanyOnboarding_Create(data).subscribe({
      next: (res) => {
        console.log("Business ERP onboarding created successfully", res);
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  userMasterOnboardingCreate(data: ERPUserMasterOnboardingRequestDTO) {
    this.erpEntityMappingService
      .ERPUserMasterOnboarding_Create(data)
      .subscribe({
        next: (res) => {
          console.log("Business User ERP onboarding created successfully", res);
        },
        error: (err) => {
          console.log(err);
        },
      });
  }

  userMasterOnboardingDelete(data: ERPUserDeleteRequestDTO) {
    this.erpEntityMappingService
      .ERPUserMasterOnboarding_Delete(data)
      .subscribe({
        next: (res) => {
          console.log("ERP user deleted successfully", res);
        },
        error: (err) => {
          console.log(err);
        },
      });
  }
}
